import {Article} from "../model/article";

export function searchInObjects(array: Article[], searchString: string): Article[] {
    if (!searchString) {
        return array; // Возвращаем весь массив, если строка поиска пустая
    }
    const lowerCaseSearchString = searchString.toLowerCase();
    return array.filter(item =>
        item.title?.toLowerCase().includes(lowerCaseSearchString) ||
        item.subTitle?.toLowerCase().includes(lowerCaseSearchString) ||
        item.text?.toLowerCase().includes(lowerCaseSearchString)
    );
}